<div class="bottomsheet-dark-view" (click)="closeBottomsheet()">
  <div
    class="bottomsheet-container"
    [ngStyle]="{ height: type === 'foodFact' ? '90%' : 'auto' }"
    id="bottomsheet"
  >
    <div class="bottomsheet-header">
      <div class="bottomsheet-top" (swipedown)="swipe($event.type)">
        <div class="bottomsheet-top-indicator"></div>
      </div>

      <div
        *ngIf="type !== 'mealDetail'"
        [ngClass]="{
          center: center,
          'center-title': type === 'fastcalorie',
          'food-table': type === 'foodFact',
          'bottomsheet-food-fact-title': type === 'foodFact'
        }"
        class="bottomsheet-title"
      >
        <p>{{ title }}</p>
        <span
          *ngIf="type === 'exercise' || type === 'edit-exercise'"
          class="exercise-badge"
        >
          {{ exerciseCalorie }} کالری
        </span>
      </div>
    </div>

    <div *ngIf="type === 'weightLog'">
      <div class="bottomsheet-mid">
        <input
          type="text"
          [(ngModel)]="weight"
          placeholder=""
          (input)="activateButton()"
          attr.id="input"
          maxlength="5"
        />
        <div>کیلوگرم</div>
      </div>
      <div class="bottomsheet-submit-holder">
        <div
          *ngIf="isActivated"
          class="bottomsheet-submit-active"
          (click)="submit()"
          id="bottomsheet-submit"
        >
          ثبت
        </div>
        <div
          *ngIf="!isActivated"
          class="bottomsheet-submit-disable"
          id="bottomsheet-submit"
        >
          ثبت
        </div>
      </div>
    </div>
    <!-- <div class="bottomsheet-foodfact-second-unit">
        {{ mealSecondUnitTitle }}
      </div> -->
    <div *ngIf="type === 'foodFact'" class="bottomsheet-food-fact-table">
      <div *ngFor="let foodFactName of foodFactNames; let i = index">
        <div
          *ngIf="foodFactAmounts[i] !== -1"
          class="bottomsheet-food-fact-cell"
        >
          <div
            class="bottomsheet-food-fact-cell-background"
            [ngStyle]="{ background: i % 2 === 0 ? '#F2F2F7' : '#ffffff' }"
          ></div>
          <div class="bottomsheet-food-fact-cell-title">
            {{ foodFactName }}
          </div>
          <div class="bottomsheet-food-fact-cell-unit-holder">
            <div class="bottomsheet-food-fact-cell-amount">
              {{ foodFactAmounts[i] }}
            </div>
            <div class="bottomsheet-food-fact-cell-unit">
              {{ foodFactUnits[i] }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="type === 'mealDetail'">
      <div
        *ngFor="let food of package.foods; let i = index"
        class="bottomsheet-meal-cell"
      >
        <div class="bottomsheet-meal-food-title">{{ food.foodId.name }}:</div>
        <div class="bottomsheet-meal-food-description">
          {{ mealFoodAmounts[i].toFixed(1) }}
        </div>
      </div>
      <div class="bottomsheet-submit-holder">
        <div
          class="bottomsheet-submit-active"
          (click)="submit()"
          id="bottomsheet-submit"
        >
          انتخاب
        </div>
      </div>
    </div>
    <div *ngIf="type === 'startDay'">
      <div class="bottomsheet-start-day-container">
        <div
          class="bottomsheet-start-day-holder"
          id="bottomsheet-start-day-holder"
        >
          <div
            *ngFor="let startday of startDays; let i = index"
            class="bottomsheet-start-day-day"
          >
            {{ startday }}
          </div>
        </div>
        <div class="bottomsheet-start-day-line-top">
          <div class="bottomsheet-start-day-white-top"></div>
          <div class="bottomsheet-start-day-gradient-top"></div>
        </div>
        <div class="bottomsheet-start-day-line-bot">
          <div class="bottomsheet-start-day-gradient-bot"></div>
          <div class="bottomsheet-start-day-white-bot"></div>
        </div>
        <div
          class="bottomsheet-start-day-gesture"
          (swipeup)="swipeStartDay($event.type)"
          (swipedown)="swipeStartDay($event.type)"
        ></div>
      </div>
      <div class="bottomsheet-submit-holder">
        <div
          class="bottomsheet-submit-active"
          (click)="submit()"
          id="bottomsheet-submit"
        >
          ثبت ویرایش
        </div>
      </div>
    </div>
    <div *ngIf="type === 'fastcalorie'">
      <div class="input-wrapper">
        <input
          type="text"
          [(ngModel)]="quikCTitle"
          (input)="activeQuikAdd()"
          placeholder=" نام غذا را وارد کنید…"
        />
      </div>
      <div class="input-wrapper">
        <input
          type="tel"
          [(ngModel)]="quikCalorie"
          (input)="activeQuikAdd()"
          placeholder=" کالری غذا را وارد کنید…"
        />
        <div class="unit">کالری</div>
      </div>
      <div class="fast-cButtons">
        <div
          class="success"
          (click)="addQuikFood()"
          [ngClass]="{ blue: quikActive }"
        >
          ثبت
        </div>
        <div class="cancel" (click)="closeBottomsheet()">انصراف</div>
      </div>
    </div>
    <div *ngIf="type === 'cutome-exercise'">
      <div class="bottomsheet-mid">
        <input
          type="text"
          [(ngModel)]="activity"
          minlength="1"
          placeholder="نام فعالیت را وارد کنید..."
        />
      </div>
      <div class="bottomsheet-mid">
        <input
          type="number"
          minlength="1"
          [(ngModel)]="calorie"
          placeholder="کالری فعالیت را وارد کنید..."
        />
        <div>کالری</div>
      </div>
      <div class="bottomsheet-submit-holder button-exercise">
        <div
          class="exercise-button"
          [ngClass]="{
            active:
              calorie >= 1 &&
              activity &&
              activity.length >= 1 &&
              !customeExerciseClicked
          }"
          (click)="customeExercise()"
        >
          ثبت
        </div>
        <div class="exercise-cancel-button" (click)="closeBottomsheet()">
          انصراف
        </div>
      </div>
    </div>
    <div *ngIf="type === 'exercise'">
      <div class="bottomsheet-mid">
        <input
          type="number"
          minlength="1"
          [(ngModel)]="timeExercise"
          (ngModelChange)="exerciseCalculator($event)"
          placeholder="زمان فعالیت را وارد کنید..."
        />
        <div>دقیقه</div>
      </div>
      <div class="bottomsheet-submit-holder button-exercise">
        <div
          class="exercise-button"
          [ngClass]="{ active: timeExercise >= 1 && !exerciseLogClicked }"
          (click)="Exercise()"
        >
          ثبت
        </div>
        <div class="exercise-cancel-button" (click)="closeBottomsheet()">
          بستن
        </div>
      </div>
    </div>
    <div *ngIf="type === 'edit-exercise'">
      <div class="bottomsheet-mid">
        <input
          type="number"
          minlength="1"
          [(ngModel)]="timeExercise"
          (ngModelChange)="exerciseCalculator($event)"
          placeholder="زمان فعالیت را وارد کنید..."
        />
        <div>دقیقه</div>
      </div>
      <div class="bottomsheet-submit-holder button-exercise">
        <div
          class="exercise-button"
          [ngClass]="{ active: timeExercise >= 1 }"
          (click)="updateExercise()"
        >
          ثبت
        </div>
        <div class="exercise-cancel-button" (click)="removeExercise()">حذف</div>
      </div>
    </div>
    <div *ngIf="type === 'edit-custome-exercise'">
      <div class="bottomsheet-mid">
        <input
          type="number"
          minlength="1"
          [(ngModel)]="exerciseCalorie"
          placeholder="کالری فعالیت را وارد کنید..."
        />
        <div>کالری</div>
      </div>
      <div class="bottomsheet-submit-holder button-exercise">
        <div
          class="exercise-button"
          [ngClass]="{ active: exerciseCalorie >= 1 }"
          (click)="updateExercise()"
        >
          ثبت
        </div>
        <div class="exercise-cancel-button" (click)="removeExercise()">حذف</div>
      </div>
    </div>
    <div *ngIf="type === 'recipe-more'">
      <p class="recipe-more-title">
        {{data.title}}
      </p>
      <div class="tool-wrapper">
        <div class="tool" (click)="share()">
          <img src="assets/cookingbook/share.svg" alt=""/>
          <p>اشتراک‌گذاری</p>
        </div>
        <div class="tool" (click)="report()">
          <img src="assets/cookingbook/report.svg" alt=""/>
          <p>ثبت بازخورد</p>
        </div>

      </div>

    </div>
    <div *ngIf="type == 'recipe-report'">
      <div class="header-report">
        <img src="assets/cookingbook/report.svg" alt="">
        <p>ثبت نظر</p>
      </div>
      <p class="recipe-report-message">
        نظر شما راجع به این غذا
      </p>
      <div class="recipe-report-input">
        <input type="text" placeholder="نظر خود را بنویسید " [(ngModel)]="reportMessage">

      </div>
      <div class="recipe-report-button" (click)="sendReport()" [ngClass]="{active :reportMessage&& reportMessage.length > 0}" >ثبت</div>
    </div>
  </div>
</div>
